/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '@lm-nx-frontend/lm-inf-core';
import { IconModule, KeyboardFocusModule } from '@lm-nx-frontend/lm-inf-ui';
import { ConfirmationMessageComponent } from './confirmation-message.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,
  ],
  declarations: [ConfirmationMessageComponent],
})
export class ConfirmationMessageModule {}
